import { render, staticRenderFns } from "./tableModules.vue?vue&type=template&id=415ecffe&scoped=true"
import script from "./tableModules.vue?vue&type=script&lang=js"
export * from "./tableModules.vue?vue&type=script&lang=js"
import style0 from "./tableModules.vue?vue&type=style&index=0&id=415ecffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415ecffe",
  null
  
)

export default component.exports